import PropTypes from "prop-types";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ChatMessageText from "../sharedComponents/ChatMessageText/ChatMessageText";
import { getReplyPreviewText } from "./chatReplyUtils";
import "./chatReply.scss";

const ChatReplyPreviewBar = ({
  replyToTarget,
  senderName = "",
  onCancel,
  className = "",
}) => {
  const { t } = useTranslation("common");
  if (!replyToTarget) return null;

  return (
    <div className={`chat-reply-preview-bar ${className}`.trim()}>
      <div className="chat-reply-preview-content">
        <span className="chat-reply-preview-label">
          {t("one_to_one.replying_to") || "Replying to"}{" "}
          <strong>{senderName}</strong>
        </span>
        <span className="chat-reply-preview-text">
          <ChatMessageText
            text={getReplyPreviewText(replyToTarget, t)}
            inline
            paragraphClassName="chat-reply-quote-line"
          />
        </span>
      </div>
      <button
        type="button"
        className="chat-reply-preview-close"
        aria-label={t("one_to_one.cancel_reply") || "Cancel reply"}
        onClick={onCancel}
      >
        <CloseOutlined />
      </button>
    </div>
  );
};

ChatReplyPreviewBar.propTypes = {
  replyToTarget: PropTypes.object,
  senderName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ChatReplyPreviewBar;
